import type { GameCommand } from "../../semantic-command";
import type { GameplayEvaluationReceipt } from "../shared/adapter";
import type { EndlessRunnerSpec } from "./spec";

export function repairCommandsForEndlessRunner(spec: EndlessRunnerSpec, failedReceipt: GameplayEvaluationReceipt): readonly GameCommand[] | null {
  const failed = new Set(failedReceipt.checks.filter((check) => !check.passed).map((check) => check.id));
  if (!failed.size) return null;
  const params: Record<string, number> = {};
  // The ramp compresses arrival gaps and shrinks late danger windows;
  // dropping it is the least-destructive fix, tried first alongside the
  // straightforward loosening.
  if ((spec.params.speedRampPercent ?? 0) > 0 && (failed.has("jump-clears-obstacle") || failed.has("gap-allows-recovery"))) {
    params.speedRampPercent = 0;
  }
  if (failed.has("jump-clears-obstacle")) {
    params.jumpVelocity = 1_000;
    params.gravity = 900;
  }
  if (failed.has("gap-allows-recovery")) {
    params.minGapSeconds = 4;
  }
  return Object.keys(params).length ? [{ type: "set-params", params }] : null;
}
